
import { mapState } from 'vuex'

const globalDrawer = {
  data () {
    return {
      globalDrawer: {
        visibility: false,
        type: '',
        data: {},
        filters: {}
      }
    }
  },

  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    })
  },

  methods: {
    openGlobalDrawer ({ type, data = {}, filters = {} }) {
      this.globalDrawer = {
        visibility: true,
        type,
        data,
        filters
      }
    },

    closeGlobalDrawer (reload = null) {
      this.globalDrawer = {
        visibility: false,
        type: '',
        data: {},
        filters: {}
      }

      reload && this.$emit('reloadData')
    }
  },

  watch: {
    selectedCompany () {
      this.closeGlobalDrawer()
    },

    filters: {
      deep: true,
      handler () {
        this.closeGlobalDrawer()
      }
    }
  }
}

export default globalDrawer
